import React from 'react';
import { cn } from '../ui/cn';
import { DOOR_DESIGNER_STAGES } from './stages';

export const StageProgress: React.FC<{
  stageIndex: number;
  onSelectStage: (index: number) => void;
}> = ({ stageIndex, onSelectStage }) => (
  <nav
    aria-label="Design progress"
    className="shrink-0 overflow-x-auto border-b border-border bg-card"
  >
    <ol className="m-0 flex min-w-max list-none items-stretch p-0">
      {DOOR_DESIGNER_STAGES.map((stage, index) => {
        const current = index === stageIndex;
        return (
          <li key={stage.id} className="relative m-0 min-w-[9.5rem] list-none flex-1 p-0">
            <button
              type="button"
              aria-current={current ? 'step' : undefined}
              onClick={() => onSelectStage(index)}
              className="door-designer-step flex h-full w-full items-start gap-2.5 px-4 py-3 text-left"
            >
              <span
                className={cn(
                  'mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold',
                  current
                    ? 'border border-solid border-primary bg-primary text-primary-foreground'
                    : 'border border-solid border-primary bg-card text-primary'
                )}
              >
                {index + 1}
              </span>
              <span className="flex min-w-0 flex-col gap-0.5">
                <span className="text-xs font-semibold uppercase tracking-wide text-foreground">
                  {stage.stepperLabel}
                </span>
                <span className="text-xs text-muted-foreground">{stage.stepperHint}</span>
              </span>
            </button>
            {current ? (
              <span aria-hidden className="absolute inset-x-0 bottom-0 h-[3px] bg-primary" />
            ) : null}
          </li>
        );
      })}
    </ol>
  </nav>
);
